import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiConfig } from "@visioni/a3s-client-api/app";
import { createRoleAssignmentMutation } from "../mutations";
import { accessManagementQuery } from "../queries";

/**
 * Hook to create a role assignment for a user in the current tenant.
 * Automatically invalidates the access management query on success.
 *
 * @example
 * ```tsx
 * const { mutate, isPending } = useCreateRoleAssignment();
 *
 * const handleAssign = () => {
 *   mutate({ user: userId, role: "tenant_admin" });
 * };
 * ```
 */
export function useCreateRoleAssignment() {
  const apiConfig = useApiConfig();
  const queryClient = useQueryClient();

  const mutationApiConfig = {
    tenantId: apiConfig.tenant?.tenantId,
    apiBaseUrl: apiConfig.tenant?.apiBaseUrl,
    authenticatedFetch: apiConfig.authenticatedFetch,
  };

  return useMutation({
    ...createRoleAssignmentMutation(mutationApiConfig, {}),
    onSuccess: () => {
      const queryKey = accessManagementQuery(apiConfig, {}).queryKey;
      void queryClient.invalidateQueries({ queryKey });
    },
  });
}
